import { Navigate, useLocation } from "react-router-dom";
import { isFullyAuthenticatedForApp } from "@/utils/helper";
import { useProfileStore } from "@/store/profile";

type Props = { children: React.ReactNode };

export function RedirectIfAuth({ children }: Props) {
  const location = useLocation();
  const profileAuthInfo = useProfileStore((s) => s.profileAuthInfo);
  const currentPatient = useProfileStore((s) => s.currentPatient);

  if (isFullyAuthenticatedForApp(profileAuthInfo, currentPatient)) {
    const from = (location.state as { from?: { pathname?: string } })?.from?.pathname;
    return <Navigate to={from ?? "/"} replace />;
  }
  return <>{children}</>;
}
